import { ApiService } from "@/api";

export default {
  GET_LIST_ORGS({ commit }, payload) {
    return ApiService.org
      .getList({
        search: encodeURI(payload.query) || "",
        page: payload.page,
        count: payload.count,
      })
      .then((data) => commit("SET_LIST_ORGS", data));
  },
  GET_LIST_ORGS_SELECT({ commit }, payload) {
    return ApiService.org
      .getListSelect({
        search: encodeURI(payload.query) || "",
        page: payload.page,
        count: payload.count,
      })
      .then((data) => commit("SET_LIST_ORGS", data));
  },
  GET_LIST_ORGS_APPEND({ commit }, payload) {
    return ApiService.org
      .getList({
        search: encodeURI(payload.query) || "",
        page: payload.page,
        count: payload.count,
      })
      .then((data) => {
        commit("SET_LIST_ORGS_APPEND", data);
        return data;
      });
  },
};
